import React from "react";

const getStringfromDate = (date, delimiter) => {
  if (!date) {
    return "";
  }
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  if (delimiter) {
    return `${year}${delimiter}${month}${delimiter}${day}`;
  } else return `${year}.${month}.${day}.`;
};

function getFormatDate(isoDateStr) {
  const date = new Date(isoDateStr);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
}

const getDateFromString = (dateString) => {
  if (!dateString) {
    return null;
  }

  // 숫자가 아닌 문자를 구분자로 사용
  const delimiter = dateString.replace(/\D/g, "");

  const year = parseInt(delimiter.slice(0, 4));
  const month = parseInt(delimiter.slice(4, 6)) - 1;
  const day = parseInt(delimiter.slice(6, 8));

  return new Date(year, month, day);
};

const getDateTimeFromUTCString = (dateTimeString) => {
  if (!dateTimeString) return null;

  const digits = dateTimeString.replace(/\D/g, "");

  if (digits.length < 8) return null;

  const year = parseInt(digits.slice(0, 4));
  const month = parseInt(digits.slice(4, 6)) - 1;
  const day = parseInt(digits.slice(6, 8));
  const hour = parseInt(digits.slice(8, 10)) || 0;
  const minute = parseInt(digits.slice(10, 12)) || 0;
  const second = parseInt(digits.slice(12, 14)) || 0;

  return new Date(Date.UTC(year, month, day, hour, minute, second));
};

export {
  getStringfromDate,
  getDateFromString,
  getDateTimeFromUTCString,
  getFormatDate,
};
